import { render, staticRenderFns } from "./NoSelection.vue?vue&type=template&id=130290c8&scoped=true"
import script from "./NoSelection.vue?vue&type=script&lang=js"
export * from "./NoSelection.vue?vue&type=script&lang=js"
import style0 from "./NoSelection.vue?vue&type=style&index=0&id=130290c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130290c8",
  null
  
)

export default component.exports